<template>
  <vs-select
    class="w-full"
    label="Marketing"
    v-model="selected"
    autocomplete
  >
    <vs-select-item
      :key="index"
      :value="item"
      :text="item.displayName"
      v-for="(item,index) in arrayData"
    />
  </vs-select>
</template>

<script>
import store from '@/store/store'

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          id: '',
        }
      }
    }
  },
  data () {
    return { store }
  },
  computed: {
    arrayData: {
      get () {
        return this.store.getters['user/marketing']
      }
    },
    selected: {
      get () {
        return this.data.displayName
      },
      set (val) {
        this.$emit('change', {
          displayName: val.displayName,
          email: val.email,
          photoURL: val.photoURL,
          phoneNumber: val.phoneNumber,
        })
      }
    }
  }
}
</script>
